export default __webpack_public_path__ + "static/media/bike_image6.6367368e.jfif";